export const encodeObject = (obj) => {
	const str = JSON.stringify(obj, null, 0);
	const bytes = new TextEncoder().encode(str);

	const binString = Array.from(bytes, (byte) =>
		String.fromCodePoint(byte),
	).join("");

	return btoa(binString);
};

export const decodeObjectString = (str) => {
	const binString = atob(str);
	const bytes = Uint8Array.from(binString, (m) => m.codePointAt(0));
	return new TextDecoder().decode(bytes);
};
